/**
 *
 * @param data
 * @returns {Function}
 */
export const dismissNotification = (data) => {
  return dispatch => {
    dispatch({type: "DISMISS_NOTIFICATION", data});
  }
};

/**
 *
 * @param data
 * @returns {Function}
 */
export const muteNotification = (data) => {
  return dispatch => {
    dispatch({type: "MUTE_NOTIFICATION", data});
  }
};
